import { NOTE_CHANGE_TYPE } from 'cpool-constants';
import type { ValueOf } from 'cpool-utils';
import { create } from 'zustand';

interface QueryChangeTypeState {
    changeType: ValueOf<typeof NOTE_CHANGE_TYPE>;
}

export const useChangeTypeStore = create<QueryChangeTypeState>()(() => ({
    changeType: NOTE_CHANGE_TYPE.notes,
}));

export const setChangeType = (value: QueryChangeTypeState['changeType']) => {
    useChangeTypeStore.setState(() => ({ changeType: value }));
};

export const getChangeType = () => {
    return useChangeTypeStore.getState().changeType;
};
